import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getRatecardDetails = (state) => {
  return axios.get(API + "inventory/ratecarddetails/"+state+"/",{headers: authHeader(),});
};
const getRatecardLineDetails = (state) => {
    return axios.get(API + "inventory/ratecardlinedetails/"+state+"/",{headers: authHeader(),});
  };
const RatecardService = {
    getRatecardDetails,
    getRatecardLineDetails
  };
  export default RatecardService;